export default "__VITE_ASSET__C_3Wtd5N__"